"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cardWindowArray = exports.CardWindowEnum = void 0;
var CardWindowEnum;
(function (CardWindowEnum) {
    CardWindowEnum["DAY"] = "DAY";
    CardWindowEnum["WEEK"] = "WEEK";
    CardWindowEnum["MONTH"] = "MONTH";
    CardWindowEnum["QUARTER"] = "QUARTER";
    CardWindowEnum["YEAR"] = "YEAR";
    CardWindowEnum["LIFETIME"] = "LIFETIME";
    CardWindowEnum["ONE_TIME"] = "ONE_TIME";
})(CardWindowEnum || (exports.CardWindowEnum = CardWindowEnum = {}));
exports.cardWindowArray = Object.values(CardWindowEnum);
